import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCitiesByCountryWithinRegions = (country, cities) => {
  return {
    type: actionTypes.SET_CITIES_BY_COUNTRY_WITHIN_REGIONS,
    payload: { country, cities }
  }
}
